import { BlockedRecordBlockedType } from '@exam-center/graphql';

import {
  BlockedRecordExamCenterManagerFormProvider,
  BlockedRecordExamPasserFormLogic,
  BlockedRecordExamPasserFormProvider,
  BlockedRecordProctorFormLogic,
  BlockedRecordProctorFormProvider,
  BlockedRecordStaffFormLogic,
  useBlockedRecordDetails,
} from '../..';
import { BlockedRecordCheaterFormProvider } from '../../providers/blocked-record-cheater-form-provider';
import { BlockedRecordStaffFormProvider } from '../../providers/blocked-record-staff-form-provider';
import {
  getProctorDefaultValues,
  getStaffDefaultValues,
  getExamCenterManagerDefaultValues,
  getExamPasserDefaultValues,
  getCheaterDefaultValues,
} from '../../utils';
import { BlockedRecordCheaterFormLogic } from '../blocked-record-cheater-form-logic';
import { BlockedRecordExamCenterManagerFormLogic } from '../blocked-record-exam-center-manager-form-logic';

export default function BlockedRecordFormDetails() {
  const { blockedRecord } = useBlockedRecordDetails();

  switch (blockedRecord.blockedType) {
    case BlockedRecordBlockedType.Proctor_1:
    case BlockedRecordBlockedType.Proctor_2:
    case BlockedRecordBlockedType.Proctor_3:
      return (
        <BlockedRecordProctorFormProvider
          initialValues={getProctorDefaultValues({ blockedRecord })}
        >
          <BlockedRecordProctorFormLogic />
        </BlockedRecordProctorFormProvider>
      );
    case BlockedRecordBlockedType.ExamPasser:
      return (
        <BlockedRecordExamPasserFormProvider
          initialValues={getExamPasserDefaultValues({ blockedRecord })}
        >
          <BlockedRecordExamPasserFormLogic />
        </BlockedRecordExamPasserFormProvider>
      );
    case BlockedRecordBlockedType.Cheater:
      return (
        <BlockedRecordCheaterFormProvider
          initialValues={getCheaterDefaultValues({ blockedRecord })}
        >
          <BlockedRecordCheaterFormLogic />
        </BlockedRecordCheaterFormProvider>
      );
    case BlockedRecordBlockedType.ExamCenterManager:
      return (
        <BlockedRecordExamCenterManagerFormProvider
          initialValues={getExamCenterManagerDefaultValues({ blockedRecord })}
        >
          <BlockedRecordExamCenterManagerFormLogic />
        </BlockedRecordExamCenterManagerFormProvider>
      );
    default:
      return (
        <BlockedRecordStaffFormProvider initialValues={getStaffDefaultValues({ blockedRecord })}>
          <BlockedRecordStaffFormLogic />
        </BlockedRecordStaffFormProvider>
      );
  }
}
